import { Input } from 'src/@/components/ui/input';
import { Label } from 'src/@/components/ui/label';
import { ButtonLoading } from 'src/@/components/use/ButtonLoading';

export default function PerfilGeral({
  nome,
  sobrenome,
  usuario,
  nomeFantasia,
  email,
  telefone,
  changeTelefone,
  changeNome,
  changeSobrenome,
  changeUsuario,
  changeNomeFantasia,
  changeEmail,
  submit
}) {
  return (
    <div className="grid grid-cols-1 gap-6">
      <div className="max-w-2xl">
        <div className="space-y-6">
          {/* Nome e Sobrenome */}
          <div className="flex flex-col md:flex-row gap-4">
            <div className="flex-1 space-y-2">
              <Label htmlFor="nome" className="text-xs font-semibold text-gray-500 dark:text-[#ABABAD] uppercase tracking-wider">Nome</Label>
              <Input id="nome" onChange={changeNome} value={nome} className="border-gray-200 dark:border-[#383838] dark:bg-[#1A1D21] dark:text-[#D1D2D3] focus:border-[#7C3AED]/50 focus:ring-[#7C3AED]/20 rounded-lg" />
            </div>
            <div className="flex-1 space-y-2">
              <Label htmlFor="sobrenome" className="text-xs font-semibold text-gray-500 dark:text-[#ABABAD] uppercase tracking-wider">Sobrenome</Label>
              <Input id="sobrenome" onChange={changeSobrenome} value={sobrenome} className="border-gray-200 dark:border-[#383838] dark:bg-[#1A1D21] dark:text-[#D1D2D3] focus:border-[#7C3AED]/50 focus:ring-[#7C3AED]/20 rounded-lg" />
            </div>
          </div>

          {/* Telefone */}
          <div className="flex flex-col md:flex-row gap-4">
            <div className="space-y-2">
              <Label htmlFor="telefone" className="text-xs font-semibold text-gray-500 dark:text-[#ABABAD] uppercase tracking-wider">Telefone</Label>
              <Input
                id="telefone"
                className="max-w-[250px] border-gray-200 dark:border-[#383838] dark:bg-[#1A1D21] dark:text-[#D1D2D3] focus:border-[#7C3AED]/50 focus:ring-[#7C3AED]/20 rounded-lg"
                maxLength={11}
                placeholder="11999999999"
                onChange={changeTelefone}
                value={telefone}
              />
              <span className="text-xs text-gray-400">DDD + Número</span>
            </div>
          </div>

          {/* Nome Fantasia e Email */}
          <div className="flex flex-col md:flex-row gap-4">
            <div className="flex-1 space-y-2">
              <Label htmlFor="nomeFantasia" className="text-xs font-semibold text-gray-500 dark:text-[#ABABAD] uppercase tracking-wider">Nome Fantasia</Label>
              <Input id="nomeFantasia" onChange={changeNomeFantasia} value={nomeFantasia} className="border-gray-200 dark:border-[#383838] dark:bg-[#1A1D21] dark:text-[#D1D2D3] focus:border-[#7C3AED]/50 focus:ring-[#7C3AED]/20 rounded-lg" />
            </div>
            <div className="flex-1 space-y-2">
              <Label htmlFor="email" className="text-xs font-semibold text-gray-500 dark:text-[#ABABAD] uppercase tracking-wider">Email</Label>
              <Input id="email" onChange={changeEmail} value={email} className="border-gray-200 dark:border-[#383838] dark:bg-[#1A1D21] dark:text-[#D1D2D3] focus:border-[#7C3AED]/50 focus:ring-[#7C3AED]/20 rounded-lg" />
            </div>
          </div>

          {/* Nome de usuario */}
          <div className="flex flex-col md:flex-row md:items-center gap-4">
            <div className="space-y-2">
              <Label htmlFor="usuario" className="text-xs font-semibold text-gray-500 dark:text-[#ABABAD] uppercase tracking-wider">Nome de usuário</Label>
              <Input id="usuario" onChange={changeUsuario} value={usuario} className="border-gray-200 dark:border-[#383838] dark:bg-[#1A1D21] dark:text-[#D1D2D3] focus:border-[#7C3AED]/50 focus:ring-[#7C3AED]/20 rounded-lg" />
            </div>
            <span className="text-xs text-gray-500 dark:text-[#ABABAD]">
              Ex: <strong>jose.dasilva</strong>
            </span>
          </div>
        </div>

        <div className="mt-6">
          <ButtonLoading
            onClick={submit}
            type="submit"
            className="h-9 gap-2 bg-[#7C3AED] hover:bg-[#6D28D9] text-white text-xs font-semibold rounded-lg shadow-lg shadow-violet-500/20 transition-all hover:scale-105 active:scale-95"
          >
            Salvar
          </ButtonLoading>
        </div>
      </div>
    </div>
  );
}
